import script from "./ShopPurchase.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopPurchase.vue?vue&type=script&lang=ts&setup=true"

import "./ShopPurchase.vue?vue&type=style&index=0&id=855faa94&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-855faa94"]])

export default __exports__